import React, { useState } from 'react';

const CancelRouteModal = ({ onClose, onCancelRoute }) => {
  const [cancelReason, setCancelReason] = useState('');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[100]">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm">
        <h3 className="text-xl font-bold mb-4">Cancelar Ruta</h3>

        <p className="mb-4">
          Por favor, ingresa el motivo de la cancelación. Esta acción es permanente.
        </p>

        <textarea
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          placeholder="Ej: Rotura de camioneta, entrega pospuesta, etc."
          className="w-full p-2 border rounded-md mb-4"
          rows="3"
        />

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="bg-slate-200 text-slate-800 py-2 px-4 rounded-md"
          >
            Cerrar
          </button>

          <button
            onClick={() => onCancelRoute(cancelReason)}
            disabled={!cancelReason.trim()}
            className="bg-red-600 text-white py-2 px-4 rounded-md disabled:bg-red-300"
          >
            Confirmar Cancelación
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelRouteModal;